import React from 'react';
import styled from 'styled-components';

import { PackageTitleStars } from '../PackageTitleStars';
import { displayPrice } from '../../utils';
import { colors, spacing } from '../../constants';

const PackageTitle = styled.div``;
const PriceFrom = styled.span``;
const Price = styled.span``;
const ItemColumn = styled.div``;
const SubLabel = styled.span``;

interface IProps {
    bold?: boolean;
    className?: string;
    isDiscount?: boolean;
    isTotal?: boolean;
    item: string;
    price: number;
    priceFrom?: number;
    starAmount?: number;
    subLabel?: string;
}

const BasePriceLine: React.FC<IProps> = ({
    item,
    price,
    priceFrom,
    className,
    isDiscount,
    starAmount,
    subLabel,
}) => (
    <div className={className}>
        {subLabel ? (
            <ItemColumn>
                <PackageTitle>
                    {item}
                    {starAmount && (
                        <PackageTitleStars starAmount={starAmount} />
                    )}
                </PackageTitle>
                <SubLabel>{subLabel}</SubLabel>
            </ItemColumn>
        ) : starAmount ? (
            <PackageTitle>
                {item} <PackageTitleStars starAmount={starAmount} />
            </PackageTitle>
        ) : (
            item
        )}
        <Price>
            {isDiscount && '-'}{' '}
            {priceFrom && <PriceFrom>{displayPrice(priceFrom)}</PriceFrom>}
            {displayPrice(price)}
        </Price>
    </div>
);

export const PriceLine = styled(BasePriceLine)`
    padding: ${spacing.sm} 0;
    display: flex;
    align-items: ${({ subLabel }) => (subLabel ? 'flex-end' : 'center')};
    justify-content: space-between;
    font-weight: ${({ bold }) => (bold ? 700 : 400)};
    font-size: ${({ isTotal }) => (isTotal ? '18px' : '16px')};
    color: ${({ isDiscount }) => isDiscount && colors.primary};

    ${PackageTitle} {
        display: flex;
        align-items: center;
    }

    ${PriceFrom} {
        text-decoration: line-through;
        color: grey;
        font-weight: 300;
        margin-right: 6px;
    }

    ${PackageTitleStars} {
        margin-left: 12px;
    }

    ${Price} {
        font-size: ${({ isTotal }) => (isTotal ? '20px' : '18px')};
        font-weight: ${({ bold }) => (bold ? 700 : 400)};
        font-family: 'Campton', Arial, Helvetica, sans-serif;
        color: ${({ priceFrom }) => priceFrom && colors.orange};
    }

    ${ItemColumn} {
        display: flex;
        flex-direction: column;
    }

    ${SubLabel} {
        font-size: 14px;
        color: ${colors.orange};
        margin-top: 2px;
    }
`;
